module.exports = __webpack_public_path__ + "media/images/vector-8@2x-42bbb12cdca8e8e8444ad2dbe1dd8720.png";